import React from 'react';

function PencileIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="24"
            viewBox="0 0 22 24"
            fill="none"
        >
            <path
                d="M20.139 12.368C19.9832 12.3677 19.8288 12.401 19.6848 12.466C19.5408 12.5309 19.4099 12.6262 19.2997 12.7463C19.1896 12.8665 19.1022 13.0093 19.0427 13.1663C18.9831 13.3234 18.9526 13.4918 18.9529 13.6617L18.9563 21.4163H2.36833V3.31971H9.47818C9.63355 3.32004 9.78746 3.28691 9.93107 3.22222C10.0747 3.15753 10.2052 3.06255 10.315 2.94272C10.4249 2.8229 10.512 2.6806 10.5714 2.52397C10.6307 2.36735 10.6611 2.19949 10.6608 2.03002C10.6614 1.86044 10.6312 1.69242 10.572 1.53563C10.5128 1.37884 10.4257 1.23638 10.3157 1.11647C10.2058 0.996564 10.0752 0.901572 9.93145 0.836971C9.7877 0.77237 9.63365 0.739437 9.47818 0.740072L2.36856 0.736282C1.06592 0.736282 0 1.89915 0 3.31971V21.4125C0 22.8412 1.05897 24 2.36856 24H18.9531C20.2627 24 21.3254 22.8412 21.3254 21.4125V13.6617C21.3253 13.3187 21.2002 12.9897 20.9778 12.7472C20.7554 12.5046 20.4538 12.3683 20.1392 12.3683L20.139 12.368Z"
                fill="#C86F5C"
            />
            <path
                d="M21.6637 5.53758L16.9266 0.366683C16.7036 0.13148 16.4055 0 16.0953 0C15.7851 0 15.487 0.13148 15.264 0.366683L5.09005 11.4633C4.8692 11.7035 4.74261 12.0279 4.73706 12.368V17.5392C4.73688 17.7089 4.76745 17.877 4.82702 18.0339C4.88659 18.1907 4.97399 18.3331 5.08419 18.453C5.19439 18.5729 5.32522 18.6678 5.46917 18.7323C5.61311 18.7969 5.76733 18.8298 5.92296 18.8291H10.6605C10.8159 18.8283 10.9695 18.7938 11.1125 18.7276C11.2556 18.6615 11.3851 18.565 11.4937 18.4438L21.6637 7.34719C21.8793 7.10471 21.9999 6.78018 21.9999 6.44238C21.9999 6.10458 21.8793 5.78005 21.6637 5.53758Z"
                fill="#C86F5C"
            />
        </svg>
    );
}

export default PencileIcon;
